<template>
  <article class="card">
    <div class="card-content">
      <div class="content">
        <p>Selecione um arquivo para iniciar. Para encontrar as folhas de pagamento, acesse o 
          <a href="https://www.transparencia.pr.gov.br/pte/pessoal/servidores/poderexecutivo/remuneracao?windowId=c93" target="_blank">
            Portal da Transparência PR</a>, busque pelo contribuidor e clique em "Visualizar planilha"
        </p>
        <div>
          <div class="file has-name">
            <label class="file-label">
              <input class="file-input" type="file" ref="file" @change="uploadFile" accept=".xls"/>
              <span class="file-cta">
                <span class="file-icon">
                    <i class="fas fa-upload"></i>
                </span>
                <span class="file-label">Selecione um arquivo...</span>
              </span>
              <span class="file-name">{{ file.name }}</span>
            </label>
          </div>
        </div>
      </div>

      <div class="notification is-danger" v-if="uploadError">
        Não foi possível processar a planilha. Por favor, verifique a compatibilidade do arquivo com o serviço.
      </div>
    </div>
  </article>
</template>

<script>
import PayrollService from "../../services/payroll-service";

export default {
  data() {
    return {
      file: {},
      isLoading: false,
      uploadError: false
    };
  },
  methods: {
    uploadFile() {
        if (this.$refs.file.files[0] == null) return;
        this.file = this.$refs.file.files[0];

        this.submitFile();
    },
    async submitFile() {
      const formData = new FormData();
      formData.append('file', this.file);
      let payroll;

      this.isLoading = true;

      try {
        payroll = await PayrollService.sendFile(formData);
        sessionStorage.setItem('payroll', JSON.stringify(payroll));
        this.$router.push('/payroll/edit');
      } catch(err) {
        this.uploadError = true;
      }


      this.isLoading = false;
    }
  }
};
</script>